<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="人员姓名" >
            <template slot-scope="scope">
              {{ scope.row.persons_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="职务">
            <template slot-scope="scope">
              {{ scope.row.post_title || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="是否法人">
            <template slot-scope="scope">
              {{ scope.row.is_legal_representative?'是':'否' || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="出资比例（股权占比）">
            <template slot-scope="scope">
              {{ scope.row.contribution_ratio || '-' }}
            </template>
        </el-table-column>

    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'mainPersonsList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '主要人员',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>